export const ReportingRoutes = {
  Overview: 'overview',
} as const;
